import { render, staticRenderFns } from "./ProductShow.vue?vue&type=template&id=2e585e41&scoped=true"
import script from "./ProductShow.vue?vue&type=script&lang=js"
export * from "./ProductShow.vue?vue&type=script&lang=js"
import style0 from "./ProductShow.vue?vue&type=style&index=0&id=2e585e41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e585e41",
  null
  
)

export default component.exports